<template>
  <div>
    <v-card tile flat style="background: linear-gradient(90deg, rgba(9, 141, 246, 1) 0%, rgba(187, 221, 255, 1) 100%)">
      <v-card-text class="pa-0 black--text">
        <v-row no-gutters dense>
          <v-col cols="12" md="1">
            <v-avatar tile rounded class="ma-5">
              <v-icon color="white" size="60">mdi-text-box-check</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="12" md="9" class="pa-2">
            <div class="white--text my-2 ml-1">
              <h3 class="font-weight-regular"> LAPORAN KINERJA</h3>
              <h2 class="mb-1">{{ title }} {{ jenis === 'kasek' ? 'Kepala Sekolah' : 'Fasilitator' }}</h2>
              <span class="mt-1">Program Sekolah Penggerak {{ angkatan }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <v-img :src="$imgUrl('bg_card_register.jpg')" style="width: 100%"></v-img>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card tile flat>
      <v-card-text class="pa-0">
        <div class="pa-3">
          <div v-if="useDownload" class="text-right">
            <v-btn color="pink" dark @click="$emit('download')">
              <v-icon left>mdi-text-box-check</v-icon> Unduh Laporan</v-btn
            >
          </div>

          <v-container>
            <div class="black--text my-2">
              Di Bawah ini merupakan
              <b>Daftar Laporan Kinerja Tim {{ title }}</b> Sekolah Penggerak Angkatan {{ angkatan }}
            </div>

            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="limit"
              item-key="name"
              class="elevation-0 my-2"
              hide-default-footer
            ></v-data-table>
            <v-row v-if="false">
              <v-col cols="12" md="6" sm="12">
                <v-checkbox
                  v-if="kinerja === null || Number($getDeepObj(kinerja, 'is_setuju')) === 0"
                  v-model="agree"
                  label="Kandidat diatas adalah benar merupakan kandidat yang telah saya nilai."
                />
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="text-right mt-2">
                  <template v-if="kinerja === null || Number($getDeepObj(kinerja, 'is_setuju')) === 0">
                    <v-btn text class="text-right" @click="onDisagree">Tidak Setuju</v-btn>
                    <v-btn color="primary" :disabled="!agree" @click="onAgree">Setuju</v-btn>
                  </template>
                  <template v-else>
                    <v-btn color="primary" @click="onCancel">Batal Laporan</v-btn>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title class="subtitle-1">LAPORAN KINERJA TIDAK SESUAI</v-toolbar-title>
          <v-spacer />
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
          <div>
            Berikut ini merupakan channel atau form untuk melaporkan hasil kinerja tidak sesuai, silahkan isi alasan dan
            unggah bukti berupa gambar
          </div>
          <span class="caption grey--text">Alasan</span>
          <v-textarea
            v-model="form.alasan"
            outlined
            placeholder="Tuliskan alasan ketidaksesuaian penilaian"
            single-line
          />
          <span class="caption grey--text">Unggah Bukti Gambar</span>
          <v-file-input
            v-model="form.file_bukti"
            :accept="['image/*']"
            outlined
            dense
            prepend-icon=""
            append-icon="mdi-paperclip"
            @change="onCheck"
          />
          <div class="subtitle-2 grey--text font-weight-regular">
            File yang dapat diunggah dengan format JPG/JPEG/PNG
          </div>

          <div class="text-right">
            <v-btn color="primary" depressed @click="onSubmit"><v-icon left>mdi-send</v-icon> Kirim</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    akun: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: 'Verval',
    },
    jenis: {
      type: String,
      default: 'kasek',
    },
    useDownload: {
      type: Boolean,
      default: false,
    },
    angkatan: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      agree: null,
      dialog: false,
      form: {},
      data: [],
      statistik: {},
      headers: [],
      kinerja: null,
      items: [],
      tanggal: '',
      limit: 0,
    };
  },
  methods: {
    onDisagree() {
      this.dialog = true;
    },
    onAgree() {
      this.$emit('agree');
    },
    onSubmit() {
      this.$emit('submit', this.form);
    },
    onCheck(value) {
      const size = (value && value.size) || 0;
      const max = 1500;
      const file_type = (value && value.type) || '';

      if (!value) {
        return;
      }

      if (size > max * 1000) {
        this.$error('File yang anda unggah melebihi 1.5 Megabit');
        this.$set(this.form, 'file', '');
      }

      if (file_type.split('/')[0] !== 'image') {
        this.$error('Format yang anda unggah tidak sesuai');
        this.$set(this.form, 'file', '');
      }
    },

    onCancel() {
      this.$emit('cancel');
    },

    reset() {
      this.$set(this, 'items', []);
      this.$set(this, 'form', {});
      this.$set(this, 'agree', null);
    },
  },
};
</script>
